/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SlotIntervalAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import IntervalAction from './IntervalAction/index'
import React from 'react'
import Tysiav2MinusIcon from 'DesignSystem/Svgs/Tysiav2MinusIcon/index'
import Tysiav2PlusIcon from 'DesignSystem/Svgs/Tysiav2PlusIcon/index'
import Tysiav2TenMinuteIntervalIcon from 'DesignSystem/Svgs/Tysiav2TenMinuteIntervalIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SlotIntervalAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/SlotIntervalAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let slotInterval30IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '30.is_selected',
})
let tabAppointmentOverlayOpenValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'appointment_overlay.open',
})
let globalAppointmentOverlayOpenValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'appointment_overlay.open',
})
let aggregateData = fromAggregate.any(tabAppointmentOverlayOpenValueData, globalAppointmentOverlayOpenValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let slotInterval10IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '10.is_selected',
})
let slotInterval5IsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'slot_interval',
path: '5.is_selected',
})
  return (<React.Fragment
>
<div
  data-testid="SlotIntervalAction.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1GYEdz': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<IntervalAction
  viewPath={`${viewPath}/IntervalAction`}
 id={30}
 data="slot_interval.30.is_selected"
 isSelectedSlot={slotInterval30IsSelectedValueData}
 hoverText="Full day view"
 data="tab.appointment_overlay.open"
 data="global.appointment_overlay.open"
 aggregate="/Data/aggregate.js any"
 disabled={aggregateData}
>
{childProps => (
<Tysiav2MinusIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2MinusIcon`}
 width={dtSpaceXs}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
<div
  data-testid="SlotIntervalAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z1GYEdz': dtColorsNeutral300,'--w-3-Z1GYEdz': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-4-Z1GYEdz': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
/>
<IntervalAction
  viewPath={`${viewPath}/IntervalAction`}
 id={10}
 data="slot_interval.10.is_selected"
 isSelectedSlot={slotInterval10IsSelectedValueData}
 hoverText="10 minute view"
>
{childProps => (
<Tysiav2TenMinuteIntervalIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2TenMinuteIntervalIcon`}
 width={dtSpaceXs}
 height={dtSpaceXs}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
<div
  data-testid="SlotIntervalAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-Z1GYEdz': dtColorsNeutral300,'--w-3-Z1GYEdz': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-4-Z1GYEdz': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical1}`}
/>
<IntervalAction
  viewPath={`${viewPath}/IntervalAction`}
 id={5}
 data="slot_interval.5.is_selected"
 isSelectedSlot={slotInterval5IsSelectedValueData}
 hoverText="5 minute view"
>
{childProps => (
<Tysiav2PlusIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2PlusIcon`}
 width={dtSpaceXs}
 height={dtSpaceXs}
 fill2={dtColorsWhite}
/>
)}
</IntervalAction>
</div>
{children}
</React.Fragment>)
}